export const TARIFICATION = [
    {
        "id": "42c2cb69-dcf5-4c70-adbe-3024eaec8812",
        "nombre_sms_personnalise": 1000,
        "prix_dollars": 170,
        "prix_francs": 0,
    },
    {
        "id": "bfe2edc5-abf4-4141-9e1c-dc06df6cf086",
        "nombre_sms_personnalise": 500,
        "prix_dollars": 100,
        "prix_francs": 0,
    },
    {
        "id": "7e7fce9a-0841-4c8c-a1c7-63b0b49fda39",
        "nombre_sms_personnalise": 100,
        "prix_dollars": 17,
        "prix_francs": 0,
    },
    {
        "id": "5d969f30-3313-4758-a60a-10561a539f8e",
        "nombre_sms_personnalise": 50,
        "prix_dollars": 7,
        "prix_francs": 0,
    },
    {
        "id": "3450af6f-d11d-4270-9472-cf40d36f769f",
        "nombre_sms_personnalise": 10,
        "prix_dollars": 3.5,
        "prix_francs": 0,
    },
    {
        "id": "2816d765-a182-413d-a827-f90227994778",
        "nombre_sms_personnalise": 1,
        "prix_dollars": 0.35,
        "prix_francs": 0,
    },
]



// WEBPACK FOOTER //
// ./src/data/tarification.js